import React from "react";
import { useIntl } from "react-intl";
import { IonCard, IonCardTitle, IonCardHeader } from "@ionic/react";
import FormWrapper from "./FormWrapper";
const Emergency = () => {
  const intl = useIntl();
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.forms.house_visits.emergency_details",
          })}
        </IonCardTitle>
      </IonCardHeader>
      <FormWrapper type={"emergency"} />
    </IonCard>
  );
};

export default Emergency;
